import { createContext } from 'react';

import { ApiDataType } from '@/types';

interface UserRoleContextType {
	userRoleContext: ApiDataType;
	isLoadingRole: boolean;
}

const defaultValue = {
	userRoleContext: {
		data: null,
		errorMessage: null,
	},
	isLoadingRole: true,
};

export const UserRoleContext = createContext<UserRoleContextType>(defaultValue);
